import React from 'react';

const OrderTerms = () => {
  return (
    <div className="order-terms-page">
      <h1>Order Terms</h1>
      {/* Order Terms content will go here */}
    </div>
  );
};

export default OrderTerms; 